import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import lottie from "lottie-web";
import footerLogoAnim from "../animations/footer-logo.json";

function Footer() {
  const logoRef = useRef(null);

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: logoRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: footerLogoAnim,
    });
    return () => anim.destroy();
  }, []);

  return (
    <footer className="footer-section">
      <div className="container py-5">
        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <div ref={logoRef} className="footer-logo-anim mb-3"></div>
            <p className="text-white-50">
              Empowering careers through industry-aligned professional education,
              bridging the gap between academia and real-world skills.
            </p>
          </div>

          <div className="col-lg-2 col-md-6">
            <h6 className="text-white fw-semibold mb-3">Quick Links</h6>
            <ul className="list-unstyled footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/courses">Courses</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="text-white fw-semibold mb-3">Programs</h6>
            <ul className="list-unstyled footer-links">
              <li><Link to="/courses">AI Filmmaking</Link></li>
              <li><Link to="/courses">Wealth Management</Link></li>
              <li><Link to="/courses">Business Automation</Link></li>
              <li><Link to="/courses">Remedial Education</Link></li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="text-white fw-semibold mb-3">Contact Us</h6>
            <ul className="list-unstyled footer-links">
              <li><i className="bi bi-envelope me-2"></i>support@gencollege.in</li>
              <li><i className="bi bi-telephone me-2"></i>+91 9207833844</li>
              <li><i className="bi bi-geo-alt me-2"></i>Kerala, India</li>
            </ul>
            <div className="d-flex gap-3 mt-3">
              <a href="#" className="social-icon"><i className="bi bi-facebook"></i></a>
              <a href="#" className="social-icon"><i className="bi bi-instagram"></i></a>
              <a href="#" className="social-icon"><i className="bi bi-linkedin"></i></a>
              <a href="#" className="social-icon"><i className="bi bi-youtube"></i></a>
            </div>
          </div>
        </div>

        <hr className="border-secondary my-4" />
        <div className="row mb-3">
          <div className="col-12">
            <ul className="list-inline text-center mb-0 footer-policy-links">
              <li className="list-inline-item"><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li className="list-inline-item">•</li>
              <li className="list-inline-item"><Link to="/terms-conditions">Terms & Conditions</Link></li>
              <li className="list-inline-item">•</li>
              <li className="list-inline-item"><Link to="/refund-policy">Refund Policy</Link></li>
              <li className="list-inline-item">•</li>
              <li className="list-inline-item"><Link to="/payment-policy">Payment Policy</Link></li>
              <li className="list-inline-item">•</li>
              <li className="list-inline-item"><Link to="/disclaimer">Disclaimer</Link></li>
            </ul>
          </div>
        </div>
        <p className="text-center text-white-50 mb-0 small">
          &copy; {new Date().getFullYear()} GEN Skill College. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
